import {
  Checkbox,
  Divider,
  Drawer,
  Form,
  InputNumber,
  message,
  Radio,
  Switch,
} from "antd";
import { Component } from "react";
import config from "../config/app.config";
import { AlertOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { FunSetupBalanceNotifications } from "../helpers/FunSetupBalanceNotifications";
const DEFAULT_BALANCE = 5000;

class AppSetupBalanceNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusNof: false,
      statusMute: false,
      minAmount: DEFAULT_BALANCE,
      statusCustomMinAmount: false,
    };
    this.intervalId = null;
    this.timeoutId = null;
  }

  componentDidMount() {
    // กำหนดค่าเริ่มต้นใน localStorage หากยังไม่มี
    if (localStorage.getItem("minAmount") === null) {
      localStorage.setItem("minAmount", DEFAULT_BALANCE);
    }
    if (localStorage.getItem("showNotification") === null) {
      localStorage.setItem("showNotification", "true");
    }
    if (localStorage.getItem("statusCustomMinAmount") === null) {
      localStorage.setItem("statusCustomMinAmount", "false");
    }
    if (localStorage.getItem("statusMute") === null) {
      localStorage.setItem("statusMute", "true");
    }

    const statusNof = localStorage.getItem("showNotification") === "true";
    const statusMute = localStorage.getItem("statusMute") === "true";
    const statusCustomMinAmount =
      localStorage.getItem("statusCustomMinAmount") === "true";
    const minAmount = localStorage.getItem("minAmount") || DEFAULT_BALANCE;

    this.setState({
      statusNof,
      statusMute,
      minAmount: parseInt(minAmount, 10), // แปลงค่าเป็นตัวเลข
      statusCustomMinAmount,
    });
  }

  updateSettings = (key, value) => {
    localStorage.setItem(key, value);
    this.setState({ [key]: value });
  };

  onChangSetStatusMute = (checked) => {
    this.updateSettings("statusMute", checked);
    message.success(`${checked ? "เปิด" : "ปิด"}เสียง`);
  };

  onChangCustomMinAmount = (value) => {
    this.setState({ minAmount: value });
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      localStorage.setItem("minAmount", value);
      message.success(`อัปเดตข้อมูลสำเร็จ`);
    }, 1000);
  };

  onChangMinAmount = (e) => {
    const amount = e.target.value;
    this.updateSettings("minAmount", amount);
    this.updateSettings("statusCustomMinAmount", false);
    message.success("อัปเดตข้อมูลสำเร็จ");
  };

  onChangSetStatusNof = (checked) => {
    message.success(`${checked ? "เปิด" : "ปิด"}แจ้งเตือนยอดเงินใกล้จะหมด`);
    this.updateSettings("statusNof", checked);
    if (!checked) {
      this.updateSettings("statusMute", false);
      this.updateSettings("statusCustomMinAmount", false);
      this.updateSettings("minAmount", DEFAULT_BALANCE);
    }
  };

  onChangStatusCustomMinAmount = (e) => {
    const checked = e.target.checked;
    this.updateSettings("statusCustomMinAmount", checked);
    if (checked) {
      this.updateSettings("minAmount", "");
    } else {
      this.updateSettings("minAmount", DEFAULT_BALANCE);
    }
    message.success("อัปเดตข้อมูลสำเร็จ");
  };

  formatter = (value) => {
    if (!value) return `$ 0`;
    const [start, end] = `${value}`.split(".") || [];
    const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `$ ${end ? `${v}.${end}` : `${v}`}`;
  };

  render() {
    const { onClose, openDrawer, activeBank, t } = this.props;
    const { statusNof, statusMute, minAmount, statusCustomMinAmount } =
      this.state;
    let defaultAmount = [
      { label: "เตือนเมื่อ <", amount: 5000 },
      { label: "เตือนเมื่อ <", amount: 8000 },
      { label: "เตือนเมื่อ <", amount: 10000 },
    ];
    return (
      <>
        <FunSetupBalanceNotifications
          statusNof={statusNof}
          statusMute={statusMute}
          minAmount={minAmount}
          activeBank={activeBank}
          t={t}
        />
        <Drawer
        id="DrawerNoti"
          title={
            <>
              <AlertOutlined /> ตั้งค่าแจ้งเตือนยอดเงิน          
            </>
          }
          width={378}
          onClose={() => onClose(false)}
          closable={false}
          open={openDrawer}
          styles={{
            body: {
              paddingBottom: 80,
            },
          }}
          extra={<CloseOutlined onClick={() => onClose(false)} />}
        >
          <Checkbox
            checked={statusNof}
            className="mb-3"
            onChange={(e) => this.onChangSetStatusNof(e.target.checked)}
          >
            {statusNof ? "เปิดใช้งาน" : "ปิดใช้งาน"}แจ้งเตือน                  
          </Checkbox>
          <Divider
            orientation="left"
            children={<p style={{ fontSize: "14px" }}>เสียงแจ้งเตือน</p>}
          />
          <Form.Item label="เปิด/ปิด">
            <Switch
              size="small"
              checkedChildren={<CheckOutlined style={{ fontSize: "12px" }} />}
              unCheckedChildren={<CloseOutlined style={{ fontSize: "12px" }} />}
              onChange={this.onChangSetStatusMute}
              checked={statusMute}
              disabled={!statusNof}
            />
          </Form.Item>
          <Divider
            orientation="left"
            children={
              <p style={{ fontSize: "14px" }}>แจ้งเตือนเมื่อจำนวนเงินเหลือ</p>
            }
          />
          <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 24 }}
            layout="horizontal"
            disabled={!statusNof}
            style={{ maxWidth: 600 }}
          >
            <Radio.Group
              onChange={this.onChangMinAmount}
              value={statusCustomMinAmount ? null : minAmount}
            >
              {defaultAmount?.map((item, index) => (
                <Form.Item key={index} style={{ marginBottom: "5px" }}>
                  <Radio
                    disabled={!statusNof || statusCustomMinAmount}
                    value={item.amount}
                    checked={minAmount === item.amount} // เพิ่ม property checked
                  >
                    {item?.label} {item?.amount}                                
                  </Radio>
                </Form.Item>
              ))}
            </Radio.Group>
            <Form.Item className="mt-4">
              <Checkbox
                checked={statusCustomMinAmount}
                onChange={this.onChangStatusCustomMinAmount}
                disabled={!statusNof}
              >
                น้อยกว่า
              </Checkbox>
              <InputNumber
                disabled={!statusNof || !statusCustomMinAmount}
                value={statusCustomMinAmount ? minAmount : undefined}
                formatter={this.formatter}
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                onChange={this.onChangCustomMinAmount}
              />
            </Form.Item>
          </Form>
          <Divider
            orientation="center"
            children={
              <p
                className="text-center"
                style={{ fontSize: "12px", color: "#888" }}
              >
                Version: {config.version}
              </p>
            }
          />
        </Drawer>
      </>
    );
  }
}

export default AppSetupBalanceNotifications;
